<template>
  <div v-if="companies.length" class="component company-list">
    <ul class="list-unstyled">
      <li
        v-for="(company, index) in companies"
        :key="index"
        class="company-list-item text-capitalize"
        @click="selectCompany(company)"
      >
        {{ company.orgName }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    companies: {
      type: Array,
      default: function() {
        return [];
      }
    },
    searchEnabled: {
      type: Boolean,
      default: false
    },
    portal: {
      type: String,
      default: ""
    }
  },
  methods: {
    selectCompany(company) {
      let companyInfo = {
        companyName: company.orgName,
        mdmOrgId: company.mdmOrgId,
        mdmOrgName: company.orgName,
        mdmOrgZone: company.orgZone,
        companyMaterialAccess: company.materialAccess
      };
      this.$store.dispatch("user/setCompany", companyInfo);
      this.$store.dispatch("user/setActivePage", "requestAccessPage");
    }
  }
};
</script>

<style lang="less" scoped>
.company-list {
  background: @white1;
  max-width: 345px;
  overflow-y: auto;
  border: 1px solid @gray5;
  border-radius: 5px;
  .list-unstyled {
    margin: 0;
  }
  .company-list-item {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid @gray3;
    &:hover {
      background: @gray1;
    }
  }
  .new-company {
    padding: 10px;
    font-size: 1.5rem;
    a {
      text-decoration: underline;
    }
  }
}
</style>
